import config from '../../env/config.json';

class Config {
  public getAPIAddress(): string {
    return config.API_ADDRESS;
  }

  public getMapsAPIKey(): string {
    return config.MAPS_API_KEY;
  }

  public getFrontAddress(): string {
    return config.FRONT_ADDRESS;
  }
}

export default new Config();
